import { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";

export default function Banner() {
  const [index, setIndex] = useState(0);
  const [slides, setSlides] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("https://dev-upkl.upkl.in/api/resource/NDT%20Banner?fields=[%22*%22]")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const sortedSlides = data.data
          .sort((a, b) => parseInt(a.position) - parseInt(b.position))
          .map((item, idx) => ({
            id: idx + 1,
            image: `https://dev-upkl.upkl.in${item.banner_image}`,
            mobileImage: `https://dev-upkl.upkl.in${item.mobile_banner}`,
            title: item.banner_title,
            link: item.banner_link || "#",
          }));
        setSlides(sortedSlides);
      })
      .catch((error) => setError(error.message));
  }, []);

  const handlePrev = () => {
    setIndex(index === 0 ? slides.length - 1 : index - 1);
  };

  const handleNext = () => {
    setIndex(index === slides.length - 1 ? 0 : index + 1);
  };

  if (error) {
    return <p>Error: {error}</p>;
  }

  return (
    <section id="homebanner" style={{ position: "relative" }}>
      {/* Fixed Navigation Buttons */}
      <div className="banner-buttons">
        <button className="owl-prev-btn" onClick={handlePrev}>
          <FaArrowLeftLong />
        </button>
        <button className="owl-next-btn" onClick={handleNext}>
          <FaArrowRightLong />
        </button>
      </div>

      <Carousel
        activeIndex={index}
        onSelect={(selectedIndex) => setIndex(selectedIndex)}
        fade
        indicators={false}
        controls={false}
        interval={5000}
        pause="hover"
      >
        {slides.map((slide) => (
          <Carousel.Item key={slide.id}>
            {/* <img
              src={slide.image}
              className="d-block w-100 desktop banner-image"
              alt="banner"
            /> */}
            <img
              src={slide.mobileImage}
              className="d-block w-100 mobile banner-image"
              alt="mobile banner"
            />
            <div className="banner-overlay"></div>
            {slide.title && (
              <Carousel.Caption>
                <Link target="_blank" to={slide.link}>
                  {/* <h4>{slide.title}</h4> */}
                </Link>
              </Carousel.Caption>
            )}
          </Carousel.Item>
        ))}
      </Carousel>

      <style>
        {`
          .banner-buttons {
            position: absolute;
            top: 70%;
            left: 5%;
            right: 0;
            display: flex;
            justify-content: space-between;
            width: 40px;
            z-index: 10;
          }

          .owl-prev-btn, .owl-next-btn {
            background: rgba(0, 0, 0, 0.5);
            color: white;
            border: none;
            padding: 10px 15px;
            cursor: pointer;
            font-size: 20px;
            border-radius: 10px;
          }

          .owl-prev-btn:hover, .owl-next-btn:hover {
            background: rgba(0, 0, 0, 0.8);
          }

          .desktop {
            display: block;
          }

          .mobile {
            display: none;
          }

          @media (max-width: 768px) {
            .desktop {
              display: none;
            }
            .mobile {
              display: block;
            }
          }
        `}
      </style>
    </section>
  );
}
